import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

const AboutVerified: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    fill="none"
    viewBox="0 0 80 80"
  >
    <path
      stroke={colors['--pink-500']}
      strokeWidth="3"
      d="M17.004 50.26h-1.298c.36-1.481 1.248-3.51 3.114-5.376 2.59-2.59 7.193-4.991 15.23-4.991 8.039 0 12.641 2.4 15.231 4.99 1.867 1.867 2.755 3.896 3.115 5.377H17.004zm23.075-19.206a8.525 8.525 0 11-12.056-12.057 8.525 8.525 0 0112.056 12.057z"
    />
    <path
      fill={colors['--pink-500']}
      fillRule="evenodd"
      d="M54.102 64.225C60.673 64.225 66 58.644 66 51.76c0-6.885-5.327-12.466-11.898-12.466-6.572 0-11.899 5.581-11.899 12.466 0 6.884 5.327 12.465 11.899 12.465zm6.534-16.25a.625.625 0 00.168-.455.649.649 0 00-.196-.442c-.06-.056-.272-.26-.348-.287a.57.57 0 00-.464.034.601.601 0 00-.186.154l-7.127 8.25-3.249-2.962a.58.58 0 00-.424-.172c-.158.003-.41.135-.518.255-.11.12-.274.442-.27.607.004.165.184.437.184.437l3.692 3.404.585.602.617-.7c2.972-3.382 7.536-8.726 7.536-8.726z"
      clipRule="evenodd"
    />
    <path stroke={colors['--pink-500']} strokeWidth="3" d="M1.5 1.5H78.5V78.5H1.5z" />
  </svg>
);

export default AboutVerified;
